<div class="container">

    <div class="top-row">
        <h3 class="header">AVAILABLE DATA</h3>
        <span class="select-all" (click)="selectAllProperties()">Select all</span>
    </div>

    <!-- SUPER ADMIN ONLY - START -->

    <mat-form-field class="user-type-form-field">
        <mat-label>USER DATA SET</mat-label>
        <mat-select class="user-type-select" [(ngModel)]="selectedUser" panelClass="import-select" (ngModelChange)="updateDataSetDisplay()">
            <mat-option [value]="'Super Admin'">Super Admin</mat-option>
            <mat-option *ngFor="let user of usersWithDataSets" [value]="user">{{user.first_name}} {{user.last_name}}</mat-option>
        </mat-select>
    </mat-form-field>


    <button class="edit-data-set-btn" [disabled]="selectedUser === 'Super Admin' || !selectedUser" (click)="editDataSet()">Edit Data Set</button>

    <!-- SUPER ADMIN ONLY - END -->

    <div class="properties-selection-group">
        <section *ngFor="let property of selectedDataSet.properties" class="property-selection">
            <mat-checkbox *ngIf="!property.isRestricted && includeProperty(property.propertyName)" [checked]="property.isSelected"
                [(ngModel)]="property.isSelected">{{property.propertyName}}</mat-checkbox>
        </section>
    </div>


    <button class="apply-filters-btn" (click)="applyFilters()">APPLY FILTERS</button>

</div>